import { render, staticRenderFns } from "./modalVisualizarExoneracaoObitos.vue?vue&type=template&id=68b4b6e6&scoped=true"
import script from "./modalVisualizarExoneracaoObitos.vue?vue&type=script&lang=js"
export * from "./modalVisualizarExoneracaoObitos.vue?vue&type=script&lang=js"
import style0 from "./modalVisualizarExoneracaoObitos.vue?vue&type=style&index=0&id=68b4b6e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b4b6e6",
  null
  
)

export default component.exports